// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var List_plus$ReactTemplate = require("./List_plus.bs.js");

var neighbours_deltas = /* :: */[
  /* tuple */[
    -1,
    -1
  ],
  /* :: */[
    /* tuple */[
      0,
      -1
    ],
    /* :: */[
      /* tuple */[
        1,
        -1
      ],
      /* :: */[
        /* tuple */[
          1,
          0
        ],
        /* :: */[
          /* tuple */[
            1,
            1
          ],
          /* :: */[
            /* tuple */[
              0,
              1
            ],
            /* :: */[
              /* tuple */[
                -1,
                1
              ],
              /* :: */[
                /* tuple */[
                  -1,
                  0
                ],
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]
  ]
];

function fix_outbound(arr, i) {
  if (i < 0) {
    return arr.length - 1 | 0;
  } else if (i >= arr.length) {
    return 0;
  } else {
    return i;
  }
}

function fix_outbound2(cells, param) {
  var fixedX = fix_outbound(Caml_array.caml_array_get(cells, 0), param[0]);
  var fixedY = fix_outbound(cells, param[1]);
  return /* tuple */[
          fixedX,
          fixedY
        ];
}

function count_neighbours(state, cells, param) {
  var y = param[1];
  var x = param[0];
  return List_plus$ReactTemplate.count((function (param) {
                return Caml_array.caml_array_get(Caml_array.caml_array_get(cells, param[1]), param[0]) === state;
              }), List.map((function (param) {
                    return fix_outbound2(cells, param);
                  }), List.map((function (param) {
                        return /* tuple */[
                                x + param[0] | 0,
                                y + param[1] | 0
                              ];
                      }), neighbours_deltas)));
}

function count_alive_neighbours(param, param$1) {
  return count_neighbours(/* Alive */1, param, param$1);
}

function toggle(cells, param) {
  var y = param[1];
  var x = param[0];
  var match = Caml_array.caml_array_get(Caml_array.caml_array_get(cells, y), x);
  if (match) {
    Caml_array.caml_array_set(Caml_array.caml_array_get(cells, y), x, /* Dead */0);
  } else {
    Caml_array.caml_array_set(Caml_array.caml_array_get(cells, y), x, /* Alive */1);
  }
  return cells;
}

function next_generation(cells) {
  return cells.map((function (row, y) {
                return row.map((function (cell, x) {
                              var match = count_neighbours(/* Alive */1, cells, /* tuple */[
                                    x,
                                    y
                                  ]);
                              if (cell) {
                                if (match === 3 || match === 2) {
                                  return /* Alive */1;
                                } else {
                                  return /* Dead */0;
                                }
                              } else if (match !== 3) {
                                return /* Dead */0;
                              } else {
                                return /* Alive */1;
                              }
                            }));
              }));
}

exports.neighbours_deltas = neighbours_deltas;
exports.fix_outbound = fix_outbound;
exports.fix_outbound2 = fix_outbound2;
exports.count_neighbours = count_neighbours;
exports.count_alive_neighbours = count_alive_neighbours;
exports.toggle = toggle;
exports.next_generation = next_generation;
/* No side effect */
